export default function sendMessage(message) {
  window.parent.postMessage(message, '*');
}
